




























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Stepper extends Vue {

  @Prop(Number) state!: number
  @Prop(Array) steps!: Array<object>

  contentHeight: any = 0;

  get stepperItemStyle() {
    return {
      height: this.contentHeight + 'px',
      overflow: 'scroll'
    }
  }

  mounted() {
    var vStepperContentElement = document.querySelector('.v-stepper__items');
    var actionsElement = document.querySelector('.actions');
    if( vStepperContentElement && actionsElement ) {
      this.contentHeight = window.innerHeight - vStepperContentElement.getBoundingClientRect().top - actionsElement.clientHeight - 72;
    }

    let root = this;
    window.addEventListener('resize', function(event){
      if( vStepperContentElement && actionsElement ) {
        root.contentHeight = window.innerHeight - vStepperContentElement.getBoundingClientRect().top - actionsElement.clientHeight - 72;
      }
    });
  }
}
